import { FileContent, FileContentFactory, PromotionalContent } from ".."

export interface ModifyPromotionalContent {
    isDraft: boolean
    isActive: boolean
    isDeleted: boolean
    media: FileContent
}

export class ModifyPromotionalContentFactory {
    static create(): ModifyPromotionalContent {
        return {
            isDraft: false,
            isActive: false,
            isDeleted: false,
            media: FileContentFactory.create(),
        }
    }

    static from(pcon: PromotionalContent): ModifyPromotionalContent {
        return JSON.parse(
            JSON.stringify({
                isDraft: pcon.isDraft,
                isActive: pcon.isActive,
                isDeleted: pcon.isDeleted,
                media: FileContentFactory.fromUrl(pcon.contentUrl),
            })
        )
    }
}
